export default "__VITE_ASSET__CKgha1xF__"